// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"eff553c567a7ead39869","655":"2b641dbc2e86b9082e45"}[chunkId] + ".js";
};